const mapDefaultColumns = (csvData) => {
  return csvData.slice(1);
  // .reduce((acc, row, index) => {
  //   acc[index] = row;
  //   return acc;
  // }, {});
  // .map((row) => {
  //   return row.reduce((acc, cell, index) => {
  //     const key = columns[index] ? columns[index].accessor : null;
  //      acc[key] = cell;
  //      return acc;
  //   }, {});
  // });
};

export default mapDefaultColumns;
